import React, { useEffect, useState } from 'react';

import apiService from '../services/api';
import { getFrontendVersionMetadata } from '../services/version';

const VersionItem = ({ metadata }) => {
  if (!metadata?.version) {
    return null;
  }

  return (
    <p className="inline-flex items-center gap-1.5">
      <span className="font-medium uppercase tracking-wide text-gray-500">{metadata.label}</span>
      <span>v{metadata.version}</span>
      {metadata.commit_short ? (
        <>
          <span aria-hidden="true">·</span>
          {metadata.commit_url ? (
            <a
              href={metadata.commit_url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${metadata.label} commit ${metadata.commit_short}`}
              className="hover:text-gray-600 transition-colors duration-150"
            >
              {metadata.commit_short}
            </a>
          ) : (
            <span>{metadata.commit_short}</span>
          )}
        </>
      ) : null}
    </p>
  );
};

const VersionFooter = () => {
  const [apiVersion, setApiVersion] = useState(null);
  const frontendVersion = getFrontendVersionMetadata();

  useEffect(() => {
    let isActive = true;

    apiService.platform
      .getVersion()
      .then(response => {
        if (isActive) {
          setApiVersion(response.data);
        }
      })
      .catch(() => {
        if (isActive) {
          setApiVersion(null);
        }
      });

    return () => {
      isActive = false;
    };
  }, []);

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-gray-400">
      <VersionItem metadata={frontendVersion} />
      {apiVersion ? <VersionItem metadata={apiVersion} /> : null}
    </div>
  );
};

export default VersionFooter;
